import { addDays, isAfter, setHours, subDays } from 'date-fns';

export const generateData = ({
  startValue,
  minValue,
  maxIncrement,
  minIncrement,
  maxValue,
  days,
}: {
  maxValue: number;
  minValue: number;
  startValue: number;
  maxIncrement: (date: Date) => number;
  minIncrement: number;
  days: number;
}) => {
  const data: { date: Date; value: number }[] = [];
  const startDate = subDays(new Date(), days);

  const endDate = new Date();
  let currentValue = startValue;

  for (let date = startDate; date <= endDate; date = addDays(date, 1)) {
    const times = [0, 6, 12, 18];
    times.forEach((hour) => {
      const entryDate = setHours(new Date(date), hour);

      if (isAfter(entryDate, new Date())) {
        return;
      }
      data.push({
        date: entryDate,
        value: Math.floor(currentValue * 100) / 100,
      });

      const increment =
        Math.floor(Math.random() * (maxIncrement(entryDate) - minIncrement + 1)) + minIncrement;

      currentValue = Math.max(minValue, Math.min(maxValue, currentValue + increment));
    });
  }

  return data;
};
